import React from 'react';
import Toast from './Toast';
import './ToastContainer.css';

function ToastContainer({ toasts, removeToast }) {
  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          type={toast.type}
          message={toast.message}
          title={toast.title}
          onConfirm={() => {
            toast.onConfirm?.();
            removeToast(toast.id);
          }}
          onCancel={() => {
            toast.onCancel?.();
            removeToast(toast.id);
          }}
          onClose={() => removeToast(toast.id)}
          autoClose={toast.autoClose}
          duration={toast.duration}
        />
      ))}
    </div>
  );
}

export default ToastContainer;
